const env = () => (typeof import.meta !== 'undefined' && import.meta.env ? import.meta.env : {});

export const isBillingReconciliationMockMode = () => (
  !env().PROD && (
  env().VITE_BILLING_RECONCILIATION_MOCK === 'true' ||
  env().MODE === 'test'
  )
);

const shouldUseMockFallback = (error) => {
  if (!isBillingReconciliationMockMode()) return false;
  if (
    error?.code === 'ERR_CANCELED'
    || error?.name === 'CanceledError'
    || error?.message === 'canceled'
  ) return false;
  const status = error?.response?.status;
  return !status || status === 404 || status === 501;
};

export const requestWithMockFallback = async (request, fallback) => {
  try {
    return await request();
  } catch (error) {
    if (fallback && shouldUseMockFallback(error)) return fallback();
    throw error;
  }
};

export const listPayload = (rows, extra = {}) => ({ rows, count: rows.length, ...extra });

const loadMockData = async () => {
  if (!isBillingReconciliationMockMode()) throw new Error('Billing reconciliation mock data is disabled');
  const modulePath = '../../components/billingReconciliation/mockData.js';
  return import(/* @vite-ignore */ modulePath);
};

export const uniqueCatalogRows = async () => {
  const { seedCpqRows } = await loadMockData();
  const byCode = new Map();
  for (const row of seedCpqRows) {
    if (!row.productCode || byCode.has(row.productCode)) continue;
    byCode.set(row.productCode, {
      id: `mock-catalog-${row.productCode}`,
      program: 'website',
      productCode: row.productCode,
      displayName: row.productSelection || row.productName || row.productCode,
      standardPrice: Number(row.dealerCost || 0),
      pricingTableId: null,
      source: 'mock_seed',
      reviewed: Boolean(row.isBilling),
    });
  }
  return [...byCode.values()].sort((a, b) => Number(a.reviewed) - Number(b.reviewed) || a.productCode.localeCompare(b.productCode));
};

export const mockFileHealth = async () => listPayload([
  {
    id: 'mock-health-1',
    fileKind: 'cpq',
    rowNumber: 12,
    bac: '115409',
    tier: 'warning',
    code: 'PENDING_LIVE_NOT_BILLING',
    expectedValue: 'LIVE billing row',
    actualValue: 'PENDING LIVE / not billing',
  },
  {
    id: 'mock-health-2',
    fileKind: 'gm',
    rowNumber: 18,
    bac: '239869',
    tier: 'info',
    code: 'OUT_OF_CYCLE_CREDIT',
    expectedValue: 'APR',
    actualValue: 'MAR',
  },
]);

export const mockLifecycleAlerts = async () => listPayload([
  {
    id: 'mock-alert-1',
    bac: '115409',
    code: 'BILLING_GAP_DOWNGRADE',
    severity: 'warning',
    details: {
      dealerName: 'Sawyer Chevrolet',
      summary: 'Downgrade credit posted before CPQ billing row changed.',
    },
  },
]);

export const mockCredits = async () => {
  const { seedGmRows } = await loadMockData();
  return listPayload(
    seedGmRows
      .filter((row) => Number(row.budget) < 0)
      .map((row, index) => ({
        id: `mock-credit-${index + 1}`,
        bac: row.dealerCode,
        dealerName: row.dealerName,
        productCode: row.oemProductCode,
        amount: Number(row.budget),
        serviceMonth: row.serviceMonth,
        invoiceNumber: row.invoiceNumber,
      })),
  );
};
